// composables/useLanguage.ts
import { ref } from "vue";

export function useLanguage() {
  // 当前语言（例如 zh-CN / en-US）
  const language = ref<string>(navigator.language || "zh");

  // 语言列表（浏览器可接受的所有语言）
  const languages = ref<string[]>(Array.from(navigator.languages) || [language.value]);
  
  // 简化的语言（只取前缀，例如 zh / en）
  const shortLang = ref<string>(language.value);

  // 是否中文
  const isChinese = ref<boolean>(shortLang.value === "zh");

  // 是否英文
  const isEnglish = ref<boolean>(shortLang.value === "en");

  return {
    language,
    languages,
    shortLang,
    isChinese,
    isEnglish
  };
}
